import repository from '@/repositories/Repository'

const resource = '/api/linklegacy'

export default {
  list() {
    return repository.giggle.get(`${resource}/files`).then(r => r.data)
  },

  getDownloadLink(file) {
    return repository.giggle
      .get(`${resource}/download`, {
        params: { file },
      })
      .then(r => r.data)
  },
}
